<template>
    <div class="e404-container container">
        <div class="e404-inner">
            <img 
                src="/img/logos/orange_black.png" 
                alt="SwiftWork" 
                class="e404-logo"
            >
            <h1>404: Are you lost?</h1>
            <a 
                href="/" 
                class="btn btn-primary"
            >Go Home</a>
        </div>
    </div>
</template>

<script>
export default {
  
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/404Component.vue